import ApiService, { ApiArguments } from '@/api/api_service';
import {
  GetZoomPhoneResults200Response,
  UserForDisplay,
  ZoomPhoneResultApi,
  ZoomPhoneResultApiGetZoomPhoneResultsRequest,
  GetZoomPhoneResult200Response,
  ZoomPhoneResultApiGetZoomPhoneResultRequest,
  ZoomPhoneResultApiAnalyzeZoomPhoneResultRequest,
  ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResultsRequest,
  ZoomPhoneResultApiGetZoomPhoneResultNeighborsRequest,
  GetZoomPhoneResultNeighbors200Response,
  TranscriptionStatusesZoomPhoneResults200Response,
  ZoomPhoneResultApiCreateZoomPhoneResultRequest,
  CreateZoomPhoneResult201Response,
  ZoomPhoneResultApiDeleteZoomPhoneResultRequest,
  ZoomPhoneResultApiImportZoomPhoneResultRequest,
  ZoomPhoneResultApiApproveZoomPhoneResultRequest,
} from '@/api/openapi';

export class ZoomPhoneResultApiService extends ApiService {
  api = new ZoomPhoneResultApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getZoomPhoneResults(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiGetZoomPhoneResultsRequest>,
  ) {
    return this.checkResponse<GetZoomPhoneResults200Response>(this.api.getZoomPhoneResults(request, options), errorHandlers);
  }

  async getZoomPhoneResultsCallers(
    {
      options,
      errorHandlers,
    }: ApiArguments<void> = {},
  ) {
    return this.checkResponse<UserForDisplay[]>(this.api.getZoomPhoneResultsCallers(options), errorHandlers);
  }

  async getZoomPhoneResult(
    {
      request: { id },
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiGetZoomPhoneResultRequest>,
  ) {
    return this.checkResponse<GetZoomPhoneResult200Response>(this.api.getZoomPhoneResult({ id }, options), errorHandlers);
  }

  async deleteZoomPhoneResult(
    {
      request: { id },
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiDeleteZoomPhoneResultRequest>,
  ) {
    return this.checkResponse<void>(this.api.deleteZoomPhoneResult({ id }, options), errorHandlers);
  }

  async approveZoomPhoneResult(
    {
      request: { id },
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiApproveZoomPhoneResultRequest>,
  ) {
    return this.checkResponse<void>(this.api.approveZoomPhoneResult({ id }, options), errorHandlers);
  }

  async getZoomPhoneResultNeighbors(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiGetZoomPhoneResultNeighborsRequest>,
  ) {
    return this.checkResponse<GetZoomPhoneResultNeighbors200Response>(this.api.getZoomPhoneResultNeighbors(request, options), errorHandlers);
  }

  async analyzeZoomPhoneResult(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiAnalyzeZoomPhoneResultRequest>,
  ) {
    return this.checkResponse<void>(this.api.analyzeZoomPhoneResult(request, options), errorHandlers);
  }

  async createZoomPhoneResult(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiCreateZoomPhoneResultRequest>,
  ) {
    return this.checkResponse<CreateZoomPhoneResult201Response>(this.api.createZoomPhoneResult(request, options), errorHandlers);
  }

  async importZoomPhoneResult(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiImportZoomPhoneResultRequest>,
  ) {
    return this.checkResponse<CreateZoomPhoneResult201Response>(
      this.api.importZoomPhoneResult(request, options),
      errorHandlers,
    );
  }

  async transcriptionStatusesZoomPhoneResults(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResultsRequest>,
  ) {
    return this.checkResponse<TranscriptionStatusesZoomPhoneResults200Response>(this.api.transcriptionStatusesZoomPhoneResults(request, options), errorHandlers);
  }
}
